/**
 * Author card dropups
 *
 * Adds a delay before author cards disappear. This gives enough time for the
 * user to interact with the author card while they move the mouse from the
 * avatar to the card.
 */

(function () {
    function init() {
        var items = document.querySelectorAll('.author-list-item');
        var hoverTimeout;

        Array.prototype.forEach.call(items, function (item) {
            var card = item.querySelector('.author-card');

            if (!card) {
                return;
            }

            item.addEventListener('mouseenter', function () {
                clearTimeout(hoverTimeout);

                Array.prototype.forEach.call(document.querySelectorAll('.author-card'), function (other) {
                    other.classList.remove('hovered');
                });

                card.classList.add('hovered');
            });

            item.addEventListener('mouseleave', function () {
                hoverTimeout = setTimeout(function () {
                    card.classList.remove('hovered');
                }, 800);
            });
        });
    }

    if (document.readyState !== 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
})();
